/**
 * ========================
 * CAMPUS REPORT DOMAIN MENU PROVIDER
 * ========================
 *
 * Menu configuration for the Campus Report domain.
 */

import { IconLayoutDashboard } from '@tabler/icons-react';
import { DomainMenuProvider } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';

class CampusReportMenuProvider implements DomainMenuProvider {
  domainId = 'campus-report';

  getMenuConfig() {
    return {
      domainId: this.domainId,
      items: [
        {
          id: 'campus-report-dashboard',
          label: 'Dashboard',
          path: '/app/campus-report',
          icon: <IconLayoutDashboard size={16} />,
          visible: createVisibilityCheck({ roles: ['Admin'] }),
          requiredRoles: ['Admin'],
        },
      ],
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
        description: 'Campus report dashboard menu',
      },
    };
  }
}

export const campusReportMenuProvider = new CampusReportMenuProvider();
